import png from './images/cowboys.png'

export const colors = {
  dominant: '#001B49',
  highlight: '#fcb53e',
}
export const fullname = 'Cowboys'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/cowboys.js